<section class="flex flex-col gap-3 p-3" aria-label="Item activity">
  @if (loading()) {
    <p role="status">Loading activity…</p>
  }
  @if (failure(); as message) {
    <p role="alert">{{ message }}</p>
    @if (retryable()) {
      <button type="button" (click)="retry()">Retry</button>
    }
  }
  @if (!loading() && !failure() && !rows().length) {
    <p>No activity recorded yet.</p>
  }
  <ol class="flex flex-col gap-3">
    @for (row of lines(); track row.uid) {
      <li>
        {{ row.author?.name ?? 'Former member' }} · {{ row.words }} ·
        <time [attr.datetime]="row.at">{{ row.at | dateFormat: 'relativeDate' }}</time>
      </li>
    }
  </ol>
  @if (total() > 20) {
    <nav class="flex items-center gap-3" aria-label="Activity pages">
      <button type="button" [disabled]="loading() || page() === 0" (click)="previous()">Previous</button>
      <span>Page {{ page() + 1 }}</span>
      <button type="button" [disabled]="loading() || (page() + 1) * 20 >= total()" (click)="next()">Next</button>
    </nav>
  }
</section>
